import React from 'react';
import EndUserDetailContainer from '@src/containers/EndUserDetail';

const EndUserDetail = () => <EndUserDetailContainer />;

export default EndUserDetail;
